import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.PARROT_THEATER;

export const LEVEL_COUNT = 2;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

export const REDUX_ACTIONS = {
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
};
